// src/modules/app-views/toolbox/pages/Document/actions/menuButton.js

import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownNew,
  dropdownParameters,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

const toolboxDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
      dropdownDivider,
      dropdownParameters,
    ],
  };
};

export default toolboxDocumentMenuButton;
